import { useSortable } from "@dnd-kit/sortable"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import { CSS } from "@dnd-kit/utilities"
import Question from "./Question"
import QuestionOrderButtons from "./QuestionOrderButtons"
import { validateSingeValueType } from "../../../AssessmentForm/helpers/conditionalQuestionValidator"
import { useFormikContext } from "formik"

export default function QuestionOrderGroupQuestion({
  previewMode,
  disabled,
  questionGroup,
  question,
  selectedQuestionId,
  answers,
  onSetAnswer,
  onEdit,
  onDelete,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: question.id,
    data: { questionGroup: questionGroup, question: question },
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }

  let questionConditionalResult = undefined
  let showQuestion = true
  let width = "100%"

  const { errors, values } = useFormikContext()
  const questionOrderIndex = values.questions?.findIndex(
    (question) => question?.questionGroup?.id === questionGroup.id
  )

  const questionIndex = questionGroup.questions?.findIndex(
    (questionEntry) => questionEntry.id === question.id
  )
  let hasError = false

  if (
    errors?.questions &&
    errors?.questions[questionOrderIndex]?.questionGroup?.questions &&
    errors?.questions[questionOrderIndex]?.questionGroup?.questions[
      questionIndex
    ] &&
    question.id !== selectedQuestionId
  ) {
    hasError = true
  }

  if (previewMode) {
    width = question.width || "100%"
  }

  if (question.conditionalSource && previewMode) {
    const sourceAnswer = answers.find(
      (answer) => answer.questionId === question.conditionalSource
    )

    if (sourceAnswer) {
      questionConditionalResult = validateSingeValueType(
        question,
        sourceAnswer.value
      )
    }

    if (questionConditionalResult) {
      showQuestion = questionConditionalResult.display
    } else if (question.conditionalDisplay) {
      showQuestion = false
    }
  }

  if (!showQuestion) {
    return null
  }

  return (
    <div
      className={`groupQuestion  ${myStyles.questionGroupLayout} ${
        myStyles.questionGroupLayoutQuestion
      } ${
        (isDragging || selectedQuestionId === question.id) && !previewMode
          ? myStyles.selectedBorder
          : ""
      } ${previewMode ? myStyles.questionGroupLayoutPreviewMode : ""} ${
        hasError ? myStyles.questionOrderGroupQuestionError : ""
      }`}
      ref={setNodeRef}
      style={{ ...style, width }}
    >
      <div className={myStyles.questionGroupLayoutName}>
        <Question
          previewMode={previewMode}
          disabled={disabled}
          question={question}
          conditionalConfig={questionConditionalResult}
          answers={answers}
          onSetAnswer={(answer) => {
            onSetAnswer(answer)
          }}
          isSelected={selectedQuestionId === question.id}
        />
      </div>
      {!previewMode ? (
        <div
          className={`${myStyles.questionGroupLayoutControls} ${myStyles.questionGroupLayoutControlsQuestion}`}
        >
          <QuestionOrderButtons
            onEdit={() => {
              onEdit()
            }}
            onDelete={onDelete}
            dndAttributes={attributes}
            dndListeners={listeners}
            disabled={disabled}
          />
        </div>
      ) : null}
    </div>
  )
}
